import React from "react";
import styled from "styled-components";
import { FontWeight, content } from "@glossy";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";

interface IProps {
  length: number;
  page: { from: number; to: number };
  locale?: Locale;
  onPageDown?: () => void;
  onPageUp?: () => void;
  className?: string;
}

const Root = styled.div`
  color: ${(props) => content(props, "secondary")};
  font-weight: ${FontWeight.Normal};
  line-height: 24px;
  display: flex;
  justify-content: center;
`;

const Counter = styled.div`
  width: 160px;
  text-align: center;
`;

const Pagination = ({
  length,
  page,
  locale,
  onPageUp,
  onPageDown,
  className,
}: IProps) => (
  <Root className={className}>
    <Button
      onClick={onPageDown}
      icon="chevron-small-left"
      isDisabled={page.from === 1}
      variant="tertiary"
      size="xs"
    />
    <Counter>
      {tr(locale, "CHARTY::GAUGE::PAGINATION", {
        from: page.from.toString(),
        to: page.to.toString(),
        length: length.toString(),
      })}
    </Counter>
    <Button
      onClick={onPageUp}
      icon="chevron-small-right"
      isDisabled={page.to >= length}
      variant="tertiary"
      size="xs"
    />
  </Root>
);

export default Pagination;
